import { useCallback, useEffect, useState } from 'react';
import { useUpgradeService } from '../services/upgradeService';

/**
 * The upgrade-to-Complete offer for a VIN (SC-QA-27), or null while loading, when disabled, or when it could not be
 * read: a failed lookup only hides the offer, it never blocks the page.
 */
export const useUpgradeOffer = (vin, { enabled = true } = {}) => {
    const { getUpgradeOffer } = useUpgradeService();
    const [offer, setOffer] = useState(null);

    // one path for the first load and reload(); isCurrent drops an answer that arrives after the VIN changed
    const load = useCallback(
        async (isCurrent = () => true) => {
            if (!enabled || !vin) {
                setOffer(null);
                return null;
            }
            try {
                const next = await getUpgradeOffer(vin);
                if (isCurrent()) setOffer(next);
                return next;
            } catch (error) {
                if (isCurrent()) setOffer(null);
                return null;
            }
        },
        [vin, enabled]
    );

    useEffect(() => {
        let active = true;
        load(() => active);
        return () => {
            active = false;
        };
    }, [load]);

    return { offer, reload: () => load() };
};
